var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{ref:"custom",class:["mdCustom" ,_vm.type!="transparent"?_vm.shadeIn:"", _vm.type]},[(_vm.slotShow)?_vm._t("default"):_vm._e()],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }